// extracted by mini-css-extract-plugin
export default {"image":"Image__image___QcOOQ"};